import gql from 'graphql-tag'

export const getEmbeddedSpaceQuery = gql`
    query getEmbeddedSpace($eventId: EventID!, $filters: EmbeddedSpaceFilter) {
        event(id: $eventId) {
            embeddedSpaces(filters: $filters) {
                edges {
                    node {
                        id
                        url
                        parent {
                            name
                            helpContent
                            helpContentType
                        }
                    }
                }
            }
        }
    }
`
